<!-- Copyright (c) 2020-2022 ForgeRock. All rights reserved.

This software may be modified and distributed under the terms
of the MIT license. See the LICENSE file for details. -->
<template>
  <div class="min-vh-100 d-flex flex-column fr-fullscreen-mobile">
    <!-- vchu1: styles for richmond.ca new brand -->
    <link rel="stylesheet" href="https://www.richmond.ca/__shared/templates/assets/fonts/fontawesome/css/all.min.css">
    <link rel="stylesheet" href="https://www.richmond.ca/__shared/templates/assets/css/normalize.css">
    <link rel="stylesheet" href="css/main-richmondca.css">
    <link rel="shortcut icon" type="image/jpg" href="https://www.richmond.ca/__shared/templates/assets/img/favicon/faviconMyRichmond.png">
    <link rel="apple-touch-icon image_src" href="https://www.richmond.ca/__shared/templates/assets/img/favicon/faviconMyRichmond.png">

    <!-- don't use FR journey header
    <template
      v-if="journeyHeaderEnabled && journeyHeader && (journeyLayout === 'card' || !journeyTheaterMode)"
      id="appHeader">
      <header v-html="sanitizedHeader" />
    </template>
    -->

    <!-- vchu1: richmond.ca new brand -->
    <header class="header">
        <div class="header__top">
            <div class="container">
                <nav class="menu menu--header">
                    <ul>
                        <li><a href="https://richmond.ca/">Richmond.ca</a></li>
                    </ul>
                </nav>

                <div class="gtranslate">
                    <!-- GTranslate: https://gtranslate.io/ -->
                    <select onchange="doGTranslate(this);">
                        <option value="">Translate</option>
                        <option value="en|af">Afrikaans</option>
                        <option value="en|sq">Albanian</option>
                        <option value="en|ar">Arabic</option>
                        <option value="en|hy">Armenian</option>
                        <option value="en|az">Azerbaijani</option>
                        <option value="en|eu">Basque</option>
                        <option value="en|be">Belarusian</option>
                        <option value="en|bg">Bulgarian</option>
                        <option value="en|ca">Catalan</option>
                        <option value="en|zh-CN">Chinese (Simplified)</option>
                        <option value="en|zh-TW">Chinese (Traditional)</option>
                        <option value="en|hr">Croatian</option>
                        <option value="en|cs">Czech</option>
                        <option value="en|da">Danish</option>
                        <option value="en|nl">Dutch</option>
                        <option value="en|en">English</option>
                        <option value="en|et">Estonian</option>
                        <option value="en|tl">Filipino</option>
                        <option value="en|fi">Finnish</option>
                        <option value="en|fr">French</option>
                        <option value="en|gl">Galician</option>
                        <option value="en|ka">Georgian</option>
                        <option value="en|de">German</option>
                        <option value="en|el">Greek</option>
                        <option value="en|ht">Haitian Creole</option>
                        <option value="en|iw">Hebrew</option>
                        <option value="en|hi">Hindi</option>
                        <option value="en|hu">Hungarian</option>
                        <option value="en|is">Icelandic</option>
                        <option value="en|id">Indonesian</option>
                        <option value="en|ga">Irish</option>
                        <option value="en|it">Italian</option>
                        <option value="en|ja">Japanese</option>
                        <option value="en|ko">Korean</option>
                        <option value="en|lv">Latvian</option>
                        <option value="en|lt">Lithuanian</option>
                        <option value="en|mk">Macedonian</option>
                        <option value="en|ms">Malay</option>
                        <option value="en|mt">Maltese</option>
                        <option value="en|no">Norwegian</option>
                        <option value="en|fa">Persian</option>
                        <option value="en|pl">Polish</option>
                        <option value="en|pt">Portuguese</option>
                        <option value="en|ro">Romanian</option>
                        <option value="en|ru">Russian</option>
                        <option value="en|sr">Serbian</option>
                        <option value="en|sk">Slovak</option>
                        <option value="en|sl">Slovenian</option>
                        <option value="en|es">Spanish</option>
                        <option value="en|sw">Swahili</option>
                        <option value="en|sv">Swedish</option>
                        <option value="en|th">Thai</option>
                        <option value="en|tr">Turkish</option>
                        <option value="en|uk">Ukrainian</option>
                        <option value="en|ur">Urdu</option>
                        <option value="en|vi">Vietnamese</option>
                        <option value="en|cy">Welsh</option>
                        <option value="en|yi">Yiddish</option>
                    </select>
                    <div id="google_translate_element2">
                        <div class="skiptranslate goog-te-gadget" dir="ltr" style="">
                            <div id=":0.targetLanguage"><select class="goog-te-combo"
                                    aria-label="Language Translate Widget">
                                    <option value="">Select Language</option>
                                    <option value="af">Afrikaans</option>
                                    <option value="sq">Albanian</option>
                                    <option value="am">Amharic</option>
                                    <option value="ar">Arabic</option>
                                    <option value="hy">Armenian</option>
                                    <option value="as">Assamese</option>
                                    <option value="ay">Aymara</option>
                                    <option value="az">Azerbaijani</option>
                                    <option value="bm">Bambara</option>
                                    <option value="eu">Basque</option>
                                    <option value="be">Belarusian</option>
                                    <option value="bn">Bengali</option>
                                    <option value="bho">Bhojpuri</option>
                                    <option value="bs">Bosnian</option>
                                    <option value="bg">Bulgarian</option>
                                    <option value="ca">Catalan</option>
                                    <option value="ceb">Cebuano</option>
                                    <option value="ny">Chichewa</option>
                                    <option value="zh-CN">Chinese (Simplified)</option>
                                    <option value="zh-TW">Chinese (Traditional)</option>
                                    <option value="co">Corsican</option>
                                    <option value="hr">Croatian</option>
                                    <option value="cs">Czech</option>
                                    <option value="da">Danish</option>
                                    <option value="dv">Dhivehi</option>
                                    <option value="doi">Dogri</option>
                                    <option value="nl">Dutch</option>
                                    <option value="eo">Esperanto</option>
                                    <option value="et">Estonian</option>
                                    <option value="ee">Ewe</option>
                                    <option value="tl">Filipino</option>
                                    <option value="fi">Finnish</option>
                                    <option value="fr">French</option>
                                    <option value="fy">Frisian</option>
                                    <option value="gl">Galician</option>
                                    <option value="ka">Georgian</option>
                                    <option value="de">German</option>
                                    <option value="el">Greek</option>
                                    <option value="gn">Guarani</option>
                                    <option value="gu">Gujarati</option>
                                    <option value="ht">Haitian Creole</option>
                                    <option value="ha">Hausa</option>
                                    <option value="haw">Hawaiian</option>
                                    <option value="iw">Hebrew</option>
                                    <option value="hi">Hindi</option>
                                    <option value="hmn">Hmong</option>
                                    <option value="hu">Hungarian</option>
                                    <option value="is">Icelandic</option>
                                    <option value="ig">Igbo</option>
                                    <option value="ilo">Ilocano</option>
                                    <option value="id">Indonesian</option>
                                    <option value="ga">Irish</option>
                                    <option value="it">Italian</option>
                                    <option value="ja">Japanese</option>
                                    <option value="jw">Javanese</option>
                                    <option value="kn">Kannada</option>
                                    <option value="kk">Kazakh</option>
                                    <option value="km">Khmer</option>
                                    <option value="rw">Kinyarwanda</option>
                                    <option value="gom">Konkani</option>
                                    <option value="ko">Korean</option>
                                    <option value="kri">Krio</option>
                                    <option value="ku">Kurdish (Kurmanji)</option>
                                    <option value="ckb">Kurdish (Sorani)</option>
                                    <option value="ky">Kyrgyz</option>
                                    <option value="lo">Lao</option>
                                    <option value="la">Latin</option>
                                    <option value="lv">Latvian</option>
                                    <option value="ln">Lingala</option>
                                    <option value="lt">Lithuanian</option>
                                    <option value="lg">Luganda</option>
                                    <option value="lb">Luxembourgish</option>
                                    <option value="mk">Macedonian</option>
                                    <option value="mai">Maithili</option>
                                    <option value="mg">Malagasy</option>
                                    <option value="ms">Malay</option>
                                    <option value="ml">Malayalam</option>
                                    <option value="mt">Maltese</option>
                                    <option value="mi">Maori</option>
                                    <option value="mr">Marathi</option>
                                    <option value="mni-Mtei">Meiteilon (Manipuri)</option>
                                    <option value="lus">Mizo</option>
                                    <option value="mn">Mongolian</option>
                                    <option value="my">Myanmar (Burmese)</option>
                                    <option value="ne">Nepali</option>
                                    <option value="no">Norwegian</option>
                                    <option value="or">Odia (Oriya)</option>
                                    <option value="om">Oromo</option>
                                    <option value="ps">Pashto</option>
                                    <option value="fa">Persian</option>
                                    <option value="pl">Polish</option>
                                    <option value="pt">Portuguese</option>
                                    <option value="pa">Punjabi</option>
                                    <option value="qu">Quechua</option>
                                    <option value="ro">Romanian</option>
                                    <option value="ru">Russian</option>
                                    <option value="sm">Samoan</option>
                                    <option value="sa">Sanskrit</option>
                                    <option value="gd">Scots Gaelic</option>
                                    <option value="nso">Sepedi</option>
                                    <option value="sr">Serbian</option>
                                    <option value="st">Sesotho</option>
                                    <option value="sn">Shona</option>
                                    <option value="sd">Sindhi</option>
                                    <option value="si">Sinhala</option>
                                    <option value="sk">Slovak</option>
                                    <option value="sl">Slovenian</option>
                                    <option value="so">Somali</option>
                                    <option value="es">Spanish</option>
                                    <option value="su">Sundanese</option>
                                    <option value="sw">Swahili</option>
                                    <option value="sv">Swedish</option>
                                    <option value="tg">Tajik</option>
                                    <option value="ta">Tamil</option>
                                    <option value="tt">Tatar</option>
                                    <option value="te">Telugu</option>
                                    <option value="th">Thai</option>
                                    <option value="ti">Tigrinya</option>
                                    <option value="ts">Tsonga</option>
                                    <option value="tr">Turkish</option>
                                    <option value="tk">Turkmen</option>
                                    <option value="ak">Twi</option>
                                    <option value="uk">Ukrainian</option>
                                    <option value="ur">Urdu</option>
                                    <option value="ug">Uyghur</option>
                                    <option value="uz">Uzbek</option>
                                    <option value="vi">Vietnamese</option>
                                    <option value="cy">Welsh</option>
                                    <option value="xh">Xhosa</option>
                                    <option value="yi">Yiddish</option>
                                    <option value="yo">Yoruba</option>
                                    <option value="zu">Zulu</option>
                                </select></div>Powered by <span style="white-space:nowrap"><a
                                    class="VIpgJd-ZVi9od-l4eHX-hSRGPd" href="https://translate.google.com"
                                    target="_blank"><img
                                        src="https://www.gstatic.com/images/branding/googlelogo/1x/googlelogo_color_42x16dp.png"
                                        width="37px" height="14px" style="padding-right: 3px"
                                        alt="Google Translate">Translate</a></span>
                        </div>
                    </div>
                    <script type="application/javascript">
                        function googleTranslateElementInit2() { new google.translate.TranslateElement({ pageLanguage: 'en', autoDisplay: false }, 'google_translate_element2'); }
                    </script>
                    <script
                    type="application/javascript" src="https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit2"></script>
                    <script type="application/javascript">
                        /* <![CDATA[ */
                        eval(function (p, a, c, k, e, r) { e = function (c) { return (c < a ? '' : e(parseInt(c / a))) + ((c = c % a) > 35 ? String.fromCharCode(c + 29) : c.toString(36)) }; if (!''.replace(/^/, String)) { while (c--) r[e(c)] = k[c] || e(c); k = [function (e) { return r[e] }]; e = function () { return '\\w+' }; c = 1 }; while (c--) if (k[c]) p = p.replace(new RegExp('\\b' + e(c) + '\\b', 'g'), k[c]); return p }('6 7(a,b){n{4(2.9){3 c=2.9("o");c.p(b,f,f);a.q(c)}g{3 c=2.r();a.s(\'t\'+b,c)}}u(e){}}6 h(a){4(a.8)a=a.8;4(a==\'\')v;3 b=a.w(\'|\')[1];3 c;3 d=2.x(\'y\');z(3 i=0;i<d.5;i++)4(d[i].A==\'B-C-D\')c=d[i];4(2.j(\'k\')==E||2.j(\'k\').l.5==0||c.5==0||c.l.5==0){F(6(){h(a)},G)}g{c.8=b;7(c,\'m\');7(c,\'m\')}}', 43, 43, '||document|var|if|length|function|GTranslateFireEvent|value|createEvent||||||true|else|doGTranslate||getElementById|google_translate_element2|innerHTML|change|try|HTMLEvents|initEvent|dispatchEvent|createEventObject|fireEvent|on|catch|return|split|getElementsByTagName|select|for|className|goog|te|combo|null|setTimeout|500'.split('|'), 0, {}))
                        /* ]]> */
                    </script>
                </div>
            </div>
        </div>
        <div class="header__main">
            <div class="container"><span class="logo">
                <img src="https://www.richmond.ca/__shared/templates/assets/img/MyRichmondLogo.png" alt="MyRichmond - One Step, A Whole City" width="225" height="60">
            </span></div>
        </div>
    </header>

    <br>
    <main
      v-if="!journeyLayout || journeyLayout === 'card' || !journeyTheaterMode"
      class="px-0 flex-grow-1 d-flex container">
      <!-- vchu1: richmond.ca new brand -->
      <div class="container-login">
        <!-- vchu1: richmond.ca new brand -->
        <div class="sidebar" v-if="isLogin && isLoginScreen">
          <div class="hero hero--sidebar">
              <img src="https://www.richmond.ca/__shared/templates/assets/img/banners/MyRichmondApp.jpg" alt="">
          </div>
          <!-- vchu1: richmond.ca new brand: removed as per Grant's request:
          <div id="aboutmyrichmond">
              <h2>About MyRichmond</h2>
              <details>
                  <summary>Included Services</summary>
                  <ul>
                      <li>Register for programs</li>
                      <li>Search for available classes &amp; activities</li>
                      <li>Search Calendar of Events based on your interests and location</li>
                      <li>Access property tax account information</li>
                      <li>Access utility account information</li>
                      <li>View garbage and recycling collection schedule</li>
                      <li>Request a service or report a problem</li>
                      <li>Submit feedback online</li>
                      <li>Sign up for emergency notifications and/or Crime Prevention newsletters</li>
                      <li>Manage business licences</li>
                  </ul>
              </details>
          </div> -->
          <div id="aboutpasskey">
              <h2>New Ways to Secure your MyRichmond Account</h2>
              <p>Protecting your online safety is paramount. That is why the City of Richmond is introducing two
                  innovative approaches to safeguarding your digital identity when using MyRichmond. Choose
                  between the following options:</p>
              <details>
                  <summary>Passkeys</summary>
                  <p>Passkeys replace passwords and provide a highly secure method to authenticate your identity.
                      They use a highly secure log-in process that does not require a password, so it cannot be
                      stolen by cyber criminals. Passkeys are securely stored on your device and are only
                      accessible by you. Passkeys are receiving broad support from web platforms such as Apple,
                      Google, Microsoft and Amazon and will soon become commonplace. </p>
                  <p>Registering for a passkey is simple. All you need is a device capable of securely storing and
                      presenting your passkey when you login to MyRichmond. This includes macOS and iOS based
                      devices (Macbooks, iMacs, iPhones, iPads), Android smartphones, Windows 11 based computers
                      and USB security keys, such as YubiKey devices.</p>
              </details>
              <details>
                  <summary>Two-factor authentication (2FA)</summary>
                  <p>
                      You can still choose to use two-factor authentication instead if you wish. When you choose
                      this option, you will receive a six-digit code that will be delivered to your email address.
                      You then simply enter this code when asked to confirm your identity as the final step in
                      your login process. For passkey-based login, your access is seamless and only requires you
                      to validate your identity using the built in biometric options on your device such as
                      FaceID, TouchID or fingerprint readers.
                  </p>
              </details>
          </div>
          <div class="card--app-promo">
              <img src="https://www.richmond.ca/__shared/templates/assets/img/banners/MyRichmondApp.jpg" alt="">
              <div class="card__wrapper">
                <h2 class="card__title h3">MyRichmond Mobile App</h2>
                <div class="card__content">
                  <p>One step, a whole city.</p>
                  <div class="card__app-stores">
                    <a href="https://play.google.com/store/apps/details?id=ca.richmond.myr&hl=en_US"><img src="https://www.richmond.ca/__shared/templates/assets/img/icons/GooglePlay.png" width="150" height="45" alt="Google Play"></a>
                    <a href="https://apps.apple.com/us/app/myrichmond/id6448082785"><img src="https://www.richmond.ca/__shared/templates/assets/img/icons/AppleStore.png" width="150" height="45" alt="Apple App Store"></a>
                  </div>
                </div>
              </div>
            </div>   
        </div>

        <div class="content"> <!-- style="margin-left:auto;margin-right:auto;width:600px" -->
      
      <!-- vchu1: richmond.ca new brand
      <BContainer
        class="d-flex flex-grow-1 content"
      >
        <BRow
          :class="[{'flex-row-reverse': journeyLayout === 'justified-right'}, 'align-items-center m-0 flex-grow-1']">
          <BCol :lg="journeyLayout !== 'card' ? 6 : 12">
            <section>
              <FrCenterCard
                :logo-alt-text="logoAltText || 'Logo'"
                :logo-enabled="logoEnabled && !themeLoading"
                :logo-height="logoHeight"
                :logo-path="corLogoPath"
                class="borderless"> 
                <template #center-card-header>
                  <div v-if="!loading && !themeLoading">
                    <h1 v-if="header">MyRichmond Web Portal</h1>
                    <p>
                      Welcome to MyRichmond, a web portal and service that will enhance your experience when accessing personalized City information online.
                    </p>
                    <p
                      v-if="description"
                      v-html="description" />
                  </div>
                </template>

                <template #center-card-body>-->

                  <h1 v-if="isLogin && isLoginScreen">MyRichmond Web Portal</h1>
                  <p v-if="isLogin && isLoginScreen"> Welcome to MyRichmond, a web portal and service that will enhance your experience when accessing
                    personalized City information online. </p>
                  <BCardBody
                    v-if="!loading && !themeLoading"
                    id="callbacksPanel">
                    <FrAlert
                      :show="loginFailure"
                      :dismissible="false"
                      variant="error"
                      class="p-3 text-left">
                      {{ getTranslation(errorMessage) }}
                    </FrAlert>
                    <div
                      v-if="loginFailure && linkToTreeStart">
                      <a :href="linkToTreeStart" class="btn--primary">
                        {{ $t('login.sessionTimeoutLink') }}
                      </a>
                    </div>
                    <div v-if="!(loginFailure && linkToTreeStart)" id="body-append-el">
                      <!-- for backend scripts -->
                      <form
                        @submit.prevent="nextStep"
                        class="form"
                        id="wrapper">
                        <!-- needed for GetAuthenticationApp, RecoveryCodeDisplay-->
                        <template v-if="showScriptElms">
                          <div>
                            <fieldset />
                          </div>
                          <div id="callback_0" />
                        </template>
                        <template v-if="isSelfServiceRegistration">
                          <Registration :componentList="sharedComponentList" :step="step" />
                        </template>
                        <template v-if="!isSelfServiceRegistration">
                          <!-- vchu1: richmond.ca new brand
                          <BLink v-if="isPasskeyAware" :href="passkeyLoginURL"><img v-if="isPasskeyAware" src="images/FIDO-Passkey_Icon-Black.webp" style="height:48px;margin:12px">{{ passkeyLoginLocalized }}</BLink>
                          <BRow v-if="isPasskeyAware">
                            <BCol><div style="margin-bottom:12px"> - OR - </div></BCol>
                          </BRow>
                          <BLink
                            v-if="false && nextButtonVisible && !isSelfServiceRegistration && isLogin && isLoginScreen"
                            @click="{ loginWithEmail = !loginWithEmail }">
                            <img src="images/2faicon.svg" style="height:48px;margin:12px">Login with email
                          </BLink> -->
                          <h2 v-if="isLoginScreen">Log In</h2>
                          <template
                            v-for="(component) in componentList ">
                            <Component
                              class="callback-component form-item"
                              :callback="component.callback"
                              :index="component.index"
                              :is="component.type"
                              :key="component.key"
                              :step="step"
                              v-bind="{...component.callbackSpecificProps}"
                              v-on="{
                                'next-step': (event, preventClear) => {
                                  nextStep(event, preventClear);
                                },
                                ...component.listeners}"
                              v-show="loginWithEmail"
                              />
                          </template>
                        </template>
                        <div
                          v-if="nextButtonVisible && !isMaintenance"
                          :class="['d-flex mt-3 form-item--submit'/*vchu1: richmond.ca new brand: , journeySignInButtonPosition*/]"
                        >
                          <BButton
                            type="submit"
                            :disabled="nextButtonDisabled"
                            v-show="!isPasskeyAware || loginWithEmail"
                            class="btn--primary">
                            {{ buttonTextLocalized }}
                          </BButton>
                        </div>
                        <div
                          v-if="isLogin && forgotPasswordVisible"
                          :class="['d-flex mt-3', journeySignInButtonPosition]"
                        >
                          <BLink :href="forgotPasswordURL">{{ forgotPasswordLocalized }}</BLink>
                          <BLink :href="forgotPasskeyURL">{{ forgotPasskeyLocalized }}</BLink>
                        </div>
                        <input
                          v-if="showScriptElms"
                          id="loginButton_0"
                          role="button"
                          type="submit"
                          @click.prevent="backendScriptsHandler"
                          hidden>
                          <hr/>
                          <div
                            v-if="nextButtonVisible && !isSelfServiceRegistration && isLogin && isLoginScreen"
                            :class="[/*'d-flex mt-3 */'form__description'/*vchu1: richmond.ca new brand: , journeySignInButtonPosition*/]"
                          >
                            <!-- vchu1: richmond.ca new brand -->
                            <h3>Not yet registered? </h3>
                            <p>Create your MyRichmond account today. You only need to sign-on once to access City services
                            in one place with one password.</p>
                            <a href="?realm=/cor&authIndexType=service&authIndexValue=CORPlatformRegistration2#/"
                            target="_self" class="btn--secondary">Register</a>

                            <!-- vchu1: richmond.ca new brand: <h6 class="h6">
                            <hr/>
                              Not yet registered? Create your MyRichmond account today.
                            </h6>
                            <BButton
                              href="?realm=/cor&authIndexType=service&authIndexValue=CORPlatformRegistration2#/"
                              target="_self" class="btn-register">
                              REGISTER
                            </BButton>
                            <h6 class="h6">
                              You only need to sign-on once to access City services in one place with one password.
                            <hr/>
                            </h6>-->

                            <!-- vchu1: richmond.ca new brand -->
                            <hr>
                            <h3>MyRichmond services</h3>
                            <BContainer v-if="isLoginScreen && isLogin" class="container-fluid">
                              <div class="row justify-content-center" style="margin:0px">
                                <div>
                                  <ul>
                                    <li>Register for programs</li>
                                    <li>Search for available classes &amp; activities</li>
                                    <li>Search Calendar of Events based on your interests and location</li>
                                    <li>Access property tax account information</li>
                                    <li>Access utility account information</li>
                                    <li>View garbage and recycling collection schedule</li>
                                    <li>Request a service or report a problem</li>
                                    <li>Submit feedback online</li>
                                    <li>Sign up for emergency notifications and/or Crime Prevention newsletters</li>
                                    <li>Manage business licences</li>
                                    <li>Apply for and manage permits</li>
                                  </ul>
                                </div>
                              </div>
                            </BContainer> 
                          </div>
                      </form>
                    </div>
                  </BCardBody>
                  <BCardBody v-else>
                    <div class="h-100 d-flex">
                      <div class="fr-center-card">
                        <Spinner class="mb-4" />
                      </div>
                    </div>
                  </BCardBody>
                  <BCardFooter
                    v-if="pageFooterLocalized"
                    v-html="pageFooterLocalized" />
                <!-- vchu1: richmond.ca new brand: </template>
              </FrCenterCard>
            </section>
          </BCol>
          <BCol
            v-if="journeyLayout !== 'card' && journeyJustifiedContentEnabled"
            class="d-none d-lg-block p-0"
            lg="6"> -->
            <section
              v-html="sanitizedContent"
              class="d-flex justify-content-center" />
          <!-- vchu1: richmond.ca new brand: </BCol>
        </BRow>
      </BContainer> -->
      </div>
      </div> <!-- class="container"-->
    </main>

    <!-- vchu1: richmond.ca new brand:
    <BContainer v-if="isLoginScreen && isLogin" class="container-fluid">
      <div class="row justify-content-center" style="margin:0px">
        <div>
          <p>MyRichmond services</p>
          <ul>
            <li>Register for programs</li>
            <li>Search for available classes &amp; activities</li>
            <li>Search Calendar of Events based on your interests and location</li>
            <li>Access property tax account information</li>
            <li>Access utility account information</li>
            <li>View garbage and recycling collection schedule</li>
            <li>Request a service or report a problem</li>
            <li>Submit feedback online</li>
            <li>Sign up for emergency notifications and/or Crime Prevention newsletters</li>
            <li>Manage business licences</li>
            <li>Apply for and manage permits</li>
          </ul>
        </div>
      </div>
    </BContainer> -->

    <br/>
    <!-- vchu1: richmond.ca new brand
    <div id="footer" class="footer text-muted">
      <div class="container d-flex justify-content-center">
        <p>
          <a href="mailto:myrichmondsupport@richmond.ca">myrichmondsupport@richmond.ca</a>
          <br/>
            Copyright © {{new Date().getFullYear()}} City of Richmond
        </p>
      </div>
    </div>
    -->
    <!-- vchu1: richmond.ca new brand -->
    <footer id="footer" class="centered-footer">
      <p>
          <b>City of Richmond</b><br>
          6911 No. 3 Road, Richmond, British Columbia, V6Y 2C1
      </p>
      <p>
        <a href="https://infocentre.richmond.ca/app/ask/incidents.cat/20">MyRichmond Technical Support</a>
        <br/>
        Copyright © {{new Date().getFullYear()}} City of Richmond
      </p>

      <!-- vchu1: richmond.ca new brand, but don't need this part:
      <p>
          <a href="/city-hall/city-departments/contact/service-directory.htm" title="Service Directory">Services A
              - Z</a> |
          <a href="/services/digital/getapps.htm">Mobile Apps</a> |
          <a href="/city-hall/privacydisclaimers.htm">Privacy Policy</a> |
          <a href="/city-hall/privacydisclaimers.htm">Copyright</a>
      </p>-->
      <div><b>Stay Connected</b></div>
      <div>
        <nav class="social-links">
          <ul>
            <li><a href="https://www.instagram.com/cityofrichmondbc/?hl=en" title="Follow us on Instagram"><span class="fa-brands fa-instagram"></span></a></li>
            <li><a href="https://facebook.com/cityofrichmondbc" title="Join us on Facebook"><span class="fa-brands fa-facebook"></span></a></li>
            <li><a href="https://www.twitter.com/Richmond_BC" title="Follow us on X"><span class="fa-brands fa-x-twitter"></span></a></li>
            <li><a href="https://youtube.com/cityofrichmondbc" title="Watch us on Youtube"><span class="fa-brands fa-youtube"></span></a></li>
            <li><a href="https://ca.linkedin.com/company/city-of-richmond" title="Connect with us on LinkedIn"><span class="fa-brands fa-linkedin"></span></a></li>
          </ul>
        </nav>
      </div><br>
        <!-- vchu1: richmond.ca new brand: not consistent with top page:
          <a href="https://facebook.com/cityofrichmondbc" title="Join us on Facebook"><img
                  src="https://www.richmond.ca/__shared/templates/assets/img/icons/FacebookIcon.png" alt=Facebook height="24"></a>

          &nbsp;<a href="https://youtube.com/cityofrichmondbc" title="Watch us on YouTube"><img
                  src="https://www.richmond.ca/__shared/templates/assets/img/icons/YoutubeIcon.png" alt=YouTube height="24"></a>

          &nbsp;<a href="https://instagram.com/cityofrichmondbc" title="Follow us on Instagram"><img
                  src="https://www.richmond.ca/__shared/templates/assets/img/icons/InstagramIcon.png" alt=Instagram height="24"></a>

          < ! -- vchu1: richmond.ca new brand: broken link: &nbsp;<a href="https://richmond.ca/subscribe" title="City Newsletters"><img
                  src="https://www.richmond.ca/__shared/templates/assets/img/icons/MailIcon.png" alt=Email height="24"></a> -- >

          &nbsp;<a href="https://www.twitter.com/Richmond_BC" title="Follow us on X"><span
          class="fa-brands fa-x-twitter" height="24"></span></a> -->
      
    </footer>


    <template
      v-if="journeyFooterEnabled && journeyFooter && (journeyLayout === 'card' || !journeyTheaterMode)"
      id="appFooter">
      <footer v-html="sanitizedFooter" />
    </template>
  </div>
</template>

<script>
import {
  each,
  find,
  has,
  isString,
  noop,
} from 'lodash';
import {
  BButton,
  BCardBody,
  BCardFooter,
  BCol,
  BContainer,
  BLink,
  BRow,
} from 'bootstrap-vue';
import {
  CallbackType,
  FRAuth,
  FRRecoveryCodes,
  FRStep,
  FRWebAuthn,
  SessionManager,
  WebAuthnStepType,
} from '@forgerock/javascript-sdk';
import FrCenterCard from '@forgerock/platform-shared/src/components/CenterCard';
import Spinner from '@forgerock/platform-shared/src/components/Spinner';
import FrAlert from '@forgerock/platform-shared/src/components/Alert';
import NotificationMixin from '@forgerock/platform-shared/src/mixins/NotificationMixin';
import LoginMixin from '@forgerock/platform-shared/src/mixins/LoginMixin';
import RestMixin from '@forgerock/platform-shared/src/mixins/RestMixin';
import TranslationMixin from '@forgerock/platform-shared/src/mixins/TranslationMixin';
import { getThemeIdFromStageString } from '@forgerock/platform-shared/src/utils/stage';
import i18n from '@/i18n';
import containerState from '@/containerState';
import Registration from '@/views/Registration';

const FrCallbackType = {
  ...CallbackType,
  RecoveryCodesComponent: 'RecoveryCodesComponent',
  RedirectCallback: 'RedirectCallback',
  SelectIdPCallback: 'SelectIdPCallback',
  SuspendedTextOutputCallback: 'SuspendedTextOutputCallback',
  WebAuthnComponent: 'WebAuthnComponent',
};

export default {
  name: 'Login',
  components: {
    BButton,
    BCardBody,
    BCardFooter,
    BCol,
    BContainer,
    BLink,
    BRow,
    FrAlert,
    FrCenterCard,
    Spinner,
    FrBooleanAttributeInputCallback: () => import("@/components/callbacks/BooleanAttributeInputCallback"),
    FrChoiceCallback: () => import("@/components/callbacks/ChoiceCallback"),
    FrConfirmationCallback: () => import("@/components/callbacks/ConfirmationCallback"),
    FrConsentMappingCallback: () => import("@/components/callbacks/ConsentMappingCallback"),
    FrDeviceProfileCallback: () => import("@/components/callbacks/DeviceProfileCallback"),
    FrField: () => import("@forgerock/platform-shared/src/components/Field"),
    FrHiddenValueCallback: () => import("@/components/callbacks/HiddenValueCallback"),
    FrKbaCreateCallback: () => import("@/components/callbacks/KbaCreateCallback"),
    FrPasswordCallback: () => import("@/components/callbacks/PasswordCallback"),
    FrPollingWaitCallback: () => import("@/components/callbacks/PollingWaitCallback"),
    FrReCaptchaCallback: () => import("@/components/callbacks/ReCaptchaCallback"),
    FrRecoveryCodesComponent: () => import("@/components/display/RecoveryCodes"),
    FrSelectIdPCallback: () => import("@/components/callbacks/SelectIdPCallback"),
    FrSuspendedTextOutputCallback: () => import("@/components/callbacks/SuspendedTextOutputCallback"),
    FrTermsAndConditionsCallback: () => import("@/components/callbacks/TermsAndConditionsCallback"),
    FrTextOutputCallback: () => import("@/components/callbacks/TextOutputCallback"),
    FrValidatedCreatePasswordCallback: () => import("@/components/callbacks/ValidatedCreatePasswordCallback"),
    FrWebAuthnComponent: () => import("@/components/display/WebAuthn"),
    Registration
},
  props: {
    buttonText: {
      type: String,
      default: '',
    },
    journeyFooter: {
      type: String,
      default: '',
    },
    journeyFooterEnabled: {
      type: Boolean,
      default: false,
    },
    journeyHeader: {
      type: String,
      default: '',
    },
    journeyHeaderEnabled: {
      type: Boolean,
      default: false,
    },
    journeyTheaterMode: {
      type: Boolean,
      default: false,
    },
    journeyJustifiedContent: {
      type: String,
      default: '',
    },
    journeyJustifiedContentEnabled: {
      type: Boolean,
      default: false,
    },
    journeyLayout: {
      type: String,
      default: 'card',
    },
    journeySignInButtonPosition: {
      type: String,
      default: 'flex-column',
    },
    logoAltText: {
      type: String,
      default: '',
    },
    logoEnabled: {
      type: Boolean,
      default: true,
    },
    logoHeight: {
      type: String,
      default: '40',
    },
    logoPath: {
      type: String,
      default: '',
    },
    themeLoading: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [
    NotificationMixin,
    RestMixin,
    LoginMixin,
    TranslationMixin,
  ],
  data() {
    return {
      componentList: [],
      description: '',
      errorMessage: '',
      header: '',
      hiddenValueCallbacksRefs: [],
      linkToTreeStart: '',
      loading: true,
      loginFailure: false,
      nextButtonDisabledArray: [],
      nextButtonVisible: false,
      nextStepCallbacks: [],
      nodeThemeId: undefined,
      realm: '/cor',  // vchu1: assume customer realm by default
      retry: undefined,
      showScriptElms: false,
      step: undefined,
      suspendedId: undefined,
      treeId: undefined,
      // vchu1 - cor customization
      //forgotPasswordVisible: false,
      forgotPasswordURL: "",
      forgotPasskeyURL: "",
      passkeyLoginURL: "",
      isLoginScreen: this.isLoginScreen,
      isLogin: this.isLogin,
      isPasskeyAware: this.isPasskeyAware,
      loginWithEmail: true   // set to false if want the "Login with email" link to be clicked first before the email input box is displayed
    };
  },
  computed: {
    buttonTextLocalized() {
      let submitButtonTextOverride = null;
      try {
        submitButtonTextOverride = this.getLocalizedString(this.stage.submitButtonText, i18n.locale);
      } catch (e) {
        return this.buttonText || this.$t('login.next');
      }

      return submitButtonTextOverride || this.buttonText || this.$t('login.next');
    },
    forgotPasswordVisible() {
      return this.isLoginScreen && this.stage.forgotPasswordVisible !== false;
    },
    forgotPasswordLocalized() {
      return this.$t('login.forgotPassword');
    },
    forgotPasskeyLocalized() {
      return this.$t('login.forgotPasskey');
    },
    passkeyLoginLocalized() {
      return this.$t('login.passkeyLogin');
    },
    pageFooterLocalized() {
      try {
        return this.$sanitize(this.getLocalizedString(this.stage.pageFooter, i18n.locale));
      } catch (e) {
        return null;
      }
    },
    nextButtonDisabled() {
      // checks if there are any true bool values in array
      return this.nextButtonDisabledArray.some((bool) => bool);
    },
    sanitizedContent() {
      return this.$sanitize(this.journeyJustifiedContent);
    },
    sanitizedFooter() {
      return this.$sanitize(this.journeyFooter);
    },
    sanitizedHeader() {
      return this.$sanitize(this.journeyHeader);
    },
    stage() {
      try {
        return JSON.parse(this.step.getStage());
      } catch (e) {
        if (this.step?.getStage() !== undefined) {
          return this.step.getStage();
        }
        return '';
      }
    },
    sharedComponentList() { // make componentList reactive so Registration gets re-rendered when componentList changes
      return this.componentList;
    },
    corLogoPath() {
      return require('@forgerock/platform-shared/src/assets/images/login-logo.png');
    }
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    this.$emit('component-ready');
    this.realm = urlParams.get('realm') || '/cor';  // assume customer realm by default

    this.getConfigurationInfo(this.realm)
      .then((config) => {
        this.setRealm(config);
      })
      .then(this.checkNewSession)
      .then(() => {
        this.evaluateUrlParams();
        this.nextStep();
      })
      .catch(() => {
        this.errorMessage = this.$t('login.invalidRealm');
        this.redirectToFailure(this.step);
        this.loading = false;
      });
  },
  methods: {
    /**
     * @description handler for scripts clicking on loginButton_0
     * if a script clicks on loginButton_0 we want to make sure that the
     * the hiddenValue elements values are added to the callback data structure since
     * that is what will be sent with the request
     * this function iterates through the hiddenValue dom refs to accomplish that
     */
    backendScriptsHandler() {
      this.hiddenValueCallbacksRefs.forEach((ref) => {
        const refId = ref.id;
        const refValue = ref.value;
        this.step
          .getCallbacksOfType(FrCallbackType.HiddenValueCallback)
          .find((x) => x.getOutputByName('id', '') === refId)
          .setInputValue(refValue);
      });
      this.nextStep();
    },
    backendScriptsIdsContains(matcher) {
      const typeArr = this.step.getCallbacksOfType(FrCallbackType.HiddenValueCallback)
        .map((callback) => callback.getOutputByName('id', ''));
      return typeArr.indexOf(matcher) >= 0;
    },
    buildTreeForm() {
      //console.log("route: ", this.$route);  // vchu1 debug
      //console.log("tree: ", this.treeId); // vchu1 debug: this.treeId || this.$route.params.tree
        // tree: CORPlatformRegistration
        // tree: undefined (when just login page), this.$route.params.tree=undefined, this.$route.path = '/'
      //console.log("options: ", this.$options); // vchu1 debug
      this.header = this.step.getHeader() || '';
      this.description = this.$sanitize(this.step.getDescription() || '');
      this.nextButtonVisible = true;
      this.nextButtonDisabledArray = [false];

      this.checkNodeForThemeOverride(this.stage);

      // If self-service registration, then use special Registration view.  CORPlatformRegistration2 onward uses stage to determine this which is more accurate
      let authTree = this.treeId || this.$route.params.tree;
      if ((authTree === 'CORPlatformRegistration') || (this.stage === 'regGetUserInfo')) {
        this.isSelfServiceRegistration = true;
      } else {
        this.isSelfServiceRegistration = false;
      }
      this.isMaintenance = this.stage === 'maintenance';
      console.log("authtree: ", authTree); // vchu1 debug
      this.isLoginScreen = (authTree == undefined) || (authTree === 'loginConsent') || (authTree === 'loginConsent2FA');
      console.log("isLoginScreen: ", this.isLoginScreen); // vchu1 debug
      // This differs from isLoginScreen which test if the tree is loginConsent and not necessary which stage of the login it is at
      this.isLogin = false;
      let stage = this.step ? (this.step.payload ? this.step.payload.stage : "") : "";
      // stage "login" is the original loginConsent login stage
      // stage "login2" is the Passkey-enabled loginConsent login stage
      if ((stage === "login")||(stage === "login2")||(stage === "usernamepassword")) {
          this.isLogin = true;
          // vchu1: login page will not be aware of passkey anymore: this.isPasskeyAware = (stage === "login2")||(stage === "usernamepassword");
      }
      console.log("stage: ", stage); // vchu1 debug
      console.log("isLogin: ", this.isLogin); // vchu1 debug
      console.log("isPasskeyAware: ", this.isPasskeyAware); // vchu1 debug

      // Ensure that Social Buttons appear at top of Page Node
      const pullToTop = FrCallbackType.SelectIdPCallback;
      this.step.callbacks.sort((currentCallback, otherCallback) => {
        if (currentCallback.payload.type === pullToTop) {
          return -1;
        }
        if (otherCallback.payload.type === pullToTop) {
          return 1;
        }
        return 0;
      });

      // Some callbacks don't need to render anything so forEach is used instead of map
      const componentList = [];
      let keyFromDate = Date.now();
      //console.log("step: ", this.step); //vchu1 debug
      this.step.callbacks.forEach((callback, i) => {
        // index 0 is reserved for callback_0 used in backend scripts
        const index = i + 1;

        // Special handling for Registration flow.  CORPlatformRegistration2 and onward uses stage to detect special handling, which is more accurate
        if ((authTree === 'CORPlatformRegistration')||(this.stage === 'regGetUserInfo')) {
          if (callback.getName) {
            const name = callback.getName();
            if ((name == "acceptedPOIStatement") || (name == "acceptedUATerms")) {
              this.setCallbackField(callback, 'required', true);
            }
          }
        }

        this.nextButtonDisabledArray.push(this.isCallbackRequired(callback));
        const existsInComponentList = (type) => find(componentList, (component) => component.type === `Fr${type}`);
        let type = callback.getType();

        //if (callback.getName) console.log("callback name: ", callback.getName());  // vchu1 debug
        //console.log("callback: ", callback);  // vchu1 debug
        //console.log("type: ", type);  // vchu1 debug

        if (type === FrCallbackType.RedirectCallback) {
          this.nextButtonVisible = false;
          if (callback.getOutputByName('trackingCookie')) {
            // save current step information for later resumption of tree.
            sessionStorage.setItem('authIndexValue', this.treeId || this.$route.params.tree);
            sessionStorage.setItem('step', JSON.stringify(this.step));
            sessionStorage.setItem('realm', this.realm);
          }
          const redirectUrl = callback.getOutputByName('redirectUrl');
          if (callback.getOutputByName('redirectMethod') === 'POST') {
            const redirectData = callback.getOutputByName('redirectData');
            const form = document.createElement('form');
            form.method = 'post';
            form.action = redirectUrl;

            Object.entries(redirectData).forEach(([key, value]) => {
              const hiddenField = document.createElement('input');
              hiddenField.type = 'hidden';
              hiddenField.name = key;
              hiddenField.value = value;

              form.appendChild(hiddenField);
            });

            document.body.appendChild(form);
            form.submit();
          } else {
            window.location.href = redirectUrl;
          }
          return;
        }

        // Use SDK to handle backend scripts that SDK can parse
        // Reasign type to use specific component
        if (type === FrCallbackType.TextOutputCallback || type === FrCallbackType.MetadataCallback) {
          const isWebAuthnStep = FRWebAuthn.getWebAuthnStepType(this.step) !== WebAuthnStepType.None;
          const isRecovertCodeStep = FRRecoveryCodes.isDisplayStep(this.step);
          if (isWebAuthnStep) {
            // dont call the sdk twice on the same webAuthn step
            const onlyOneWebAuthn = !existsInComponentList(FrCallbackType.WebAuthnComponent);
            if (onlyOneWebAuthn) {
              type = FrCallbackType.WebAuthnComponent;
            } else {
              return;
            }
          } else if (isRecovertCodeStep) {
            type = FrCallbackType.RecoveryCodesComponent;
          }
        }

        // Only components that need extra props or events
        const getcomponentPropsAndEvents = (componentType) => {
          const componentPropsAndEvents = {
            ChoiceCallback: () => {
              let stage;
              if (this.stage.ChoiceCallback) {
                stage = this.stage.ChoiceCallback.shift();
              }
              return { callbackSpecificProps: { stage } };
            },
            ConfirmationCallback: () => {
              let stage;
              if (this.stage.ConfirmationCallback) {
                stage = this.stage.ConfirmationCallback.shift();
              }
              return { callbackSpecificProps: { stage, variant: existsInComponentList(FrCallbackType.WebAuthnComponent) ? 'link' : 'primary' } };
            },
            ConsentMappingCallback: () => ({
              callbackSpecificProps: { callbacks: this.step.callbacks },
              listeners: ['disable-next-button', 'did-consent'],
            }),
            HiddenValueCallback: () => ({
              listeners: ['hidden-value-callback-ref'],
            }),
            KbaCreateCallback: () => ({
              callbackSpecificProps: { showHeader: !existsInComponentList(FrCallbackType.KbaCreateCallback) },
              listeners: ['disable-next-button'],
            }),
            ReCaptchaCallback: () => ({
              listeners: ['next-step-callback'],
            }),
            SelectIdPCallback: () => ({
              callbackSpecificProps: { isOnlyCallback: this.step.callbacks.length === 1 },
              listeners: ['hide-next-button', 'disable-next-button'],
            }),
            TextOutputCallback: () => ({
              listeners: ['disable-next-button', 'has-scripts', 'hide-next-button', 'next-step-callback'],
            }),
            ValidatedCreatePasswordCallback: () => {
              let stage;
              if (this.stage.ValidatedCreatePasswordCallback) {
                stage = this.stage.ValidatedCreatePasswordCallback.shift();
              }
              return {
                callbackSpecificProps: {
                  index,
                  overrideInitialPolicies: true,
                  realm: this.realm,
                  stage,
                },
                listeners: ['disable-next-button', 'next-step-callback', 'update-auth-id'],
              };
            },
            WebAuthnComponent: () => {
              const webAuthnType = FRWebAuthn.getWebAuthnStepType(this.step);
              const webAuthnPromise = this.createWebAuthnCallbackPromise(webAuthnType);
              return {
                callbackSpecificProps: { webAuthnType, webAuthnPromise },
              };
            },
          };
          return componentPropsAndEvents[componentType] ? componentPropsAndEvents[componentType]() : {};
        };

        const { callbackSpecificProps = {}, listeners = [] } = getcomponentPropsAndEvents(type);
        const component = {
          callback,
          callbackSpecificProps,
          index,
          // if the app isn't loading update existing component props
          key: this.loading ? keyFromDate += 1 : this.componentList[i].key,
          listeners: this.getListeners({ callback, index }, listeners),
          type: this.$options.components[`Fr${type}`]
            ? `Fr${type}`
            : 'FrField',
        };

        if (component.type === 'FrField' || component.type === 'FrPasswordCallback') {
          const {
            fieldType, label, name, value,
          } = this.getField(callback, index);
          const errors = this.getTranslatePolicyFailures(callback);
          component.callbackSpecificProps = {
            errors, label, name, type: fieldType, value,
          };
          if (component.type === 'FrPasswordCallback') {
            component.callbackSpecificProps = {
              errors, label, name, type: fieldType, value, stage
            };
          }
          component.listeners = this.getListeners({ callback, index }, ['input']);

          // vchu1: has password callback! and is login: Include forgot password link
          // syeung: defined on above -- this.isLoginScreen = (authTree == undefined) || (authTree === 'loginConsent');
          if (this.isLoginScreen) {  // default view = login page
            //this.forgotPasswordVisible = true;
            // vchu1 debug: console.log('store state ',this.$store.state );
            // vchu1 debug: console.log('AM URL ', "${AM_URL}");  // this only works in container where AM_URL is envsubst with env var value
            // vchu1 debug: console.log('IDM REST URL ', "${IDM_REST_URL}");  // this only works in container where AM_URL is envsubst with env var value
            // vchu1 debug: console.log('Container state ', containerState);
            const urlParams = new URLSearchParams(window.location.search);
            const goto = urlParams.get('goto');
            const passkeyParams = new URLSearchParams();
            this.forgotPasswordURL = `${containerState.env.AM_URL}/XUI/?realm=/cor&authIndexType=service&authIndexValue=CORPlatformResetPassword`;
            this.forgotPasskeyURL = `${containerState.env.AM_URL}/XUI/?realm=/cor&authIndexType=service&authIndexValue=CORPlatformResetPasskey`;
            passkeyParams.append('realm', '/cor');
            passkeyParams.append('authIndexType', 'service');
            passkeyParams.append('authIndexValue', 'loginConsentPasskey');
            if (goto) passkeyParams.append('goto', goto);
            this.passkeyLoginURL = `${containerState.env.AM_URL}/XUI/?${passkeyParams.toString()}`;
          }
        }

        const hideNextButtonCallbacks = [
          FrCallbackType.ConfirmationCallback,
          FrCallbackType.DeviceProfileCallback,
          FrCallbackType.PollingWaitCallback,
          FrCallbackType.RecoveryCodesComponent,
          FrCallbackType.SuspendedTextOutputCallback,
          FrCallbackType.WebAuthnComponent,
        ];
        this.nextButtonVisible = hideNextButtonCallbacks.indexOf(type) > -1 ? false : this.nextButtonVisible;

        console.log("buildTreeForm: component: ", component);  // !!!vchu1 debug
        componentList.push(component);
      });
      this.componentList = componentList;
    },
    // needs to happen before other query params are processed
    checkNewSession() {
      return new Promise((resolve) => {
        // need to logout if query param is present and equal to newsession
        if (new URLSearchParams(this.getCurrentQueryString()).get('arg') === 'newsession') {
          SessionManager.logout().then(() => {
            resolve();
          });
        } else {
          resolve();
        }
      });
    },
    checkNodeForThemeOverride(stage) {
      if (isString(stage)) {
        this.nodeThemeId = getThemeIdFromStageString(stage);
      } else if (stage.themeId) {
        this.nodeThemeId = stage.themeId;
      }
    },
    /**
     * @description clears and sets the reentry cookie to be deleted
     */
    clearReentryToken() {
      const date = new Date();
      date.setTime(date.getTime() + (-1 * 24 * 60 * 60 * 1000));
      document.cookie = `reentry="";expires="${date.toGMTString()}";path=/`;
    },
    /**
     * @description  Invokes WebAuthn registration or authentication
     * @param {Number} type enum number that represents WebAuthn type WebAuthnStepType.Authentication or WebAuthnStepType.Registration
     * @returns {Promise} SDK WebAuthn promise resolved when WebAuthn is completed
     */
    createWebAuthnCallbackPromise(type) {
      if (type === WebAuthnStepType.Authentication) {
        return FRWebAuthn.authenticate(this.step);
      }
      /* vchu1: No longer needed - the Journey sets the RpId appropriately and passes it to the login-ui - Override Relying Party ID for registration
      this.step.getCallbacksOfType(FrCallbackType.MetadataCallback).forEach((callback) => {
        let data = callback.getOutputByName('data');
        // .61 = richmond.ca
        // .62 = login7tst.richmond.ca
        // .63 = no overriding of RpId
        console.log('createWebAuthnCallbackPromise: RpId:' + data.relyingPartyId);
        console.log('createWebAuthnCallbackPromise: _RpId:' + data._relyingPartyId);
        // data.relyingPartyId = 'id: "login7tst.richmond.ca",';
        // data._relyingPartyId = 'login7tst.richmond.ca';
        // console.log('createWebAuthnCallbackPromise: new RpId:' + data.relyingPartyId);
        // console.log('createWebAuthnCallbackPromise: new _RpId:' + data._relyingPartyId);
      });
      */

      return FRWebAuthn.register(this.step);
    },
    /**
     * @description Look at the url and see if we are returning to a tree from an Email Suspend Node, Redirect Callback, or SAML.
     * Must be default route and contain the strings "suspendedId=" and "authIndexValue=" for Email Suspend Node.
     * Must contain the strings "state=" and "code=" and "scope=" for redirect callback.
     * Must contain reentry cookie for SAML redirect.
     */
    evaluateUrlParams() {
      const paramString = this.getCurrentQueryString();
      const params = new URLSearchParams(paramString);
      const realm = params.get('realm') || '/';
      const hash = window.location.hash || '';

      const createParamString = (urlParams) => {
        const ampersand = urlParams.toString().length > 1 ? '&' : '';
        let stringParams = '';
        urlParams.forEach((value, key) => {
          if (stringParams.length) {
            stringParams += '&';
          }
          if (key === 'authIndexValue' && urlParams.get('authIndexType') === 'service') {
            stringParams += `${key}=${value}`;
          } else {
            stringParams += `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
          }
        });
        return `${ampersand}${stringParams}`;
      };

      this.setPageTitle(hash, params);

      if (realm) params.delete('realm');
      // arg query parameter handled in checkNewSession method
      if (params.get('arg') === 'newsession') params.delete('arg');
      if (this.$route.name === 'login' && paramString.includes('suspendedId=') && paramString.includes('authIndexValue=')) {
        // setting params in vue data then deleting to remove redundant params from URL
        this.treeId = params.get('authIndexValue');
        params.delete('authIndexValue');
        params.delete('authIndexType');
        this.suspendedId = params.get('suspendedId');
        params.delete('suspendedId');

        const stringParams = createParamString(params);
        this.removeUrlParams();
        window.history.replaceState(null, null, `?realm=${this.realm}${stringParams}`);
      } else if (paramString.includes('state=') || paramString.includes('code=') || paramString.includes('scope=')) {
        this.state = params.get('state');
        params.delete('state');
        this.code = params.get('code');
        params.delete('code');
        this.scope = params.get('scope');
        params.delete('scope');

        // session storage is used to resume a tree after returning from a redirect
        const { authIndexValue, step, realm: stepRealm } = this.getStepFromStorage();
        this.treeId = authIndexValue;
        this.step = new FRStep(step.payload);
        this.realm = stepRealm;

        const stringParams = createParamString(params);
        this.removeUrlParams();
        window.history.replaceState(null, null, `?realm=${this.realm}${stringParams}`);
      } else if (this.hasReentryToken()) {
        const { authIndexValue, step, realm: stepRealm } = this.getStepFromStorage();
        if (authIndexValue && step && step.payload) {
          this.treeId = authIndexValue;
          this.step = new FRStep(step.payload);
          this.realm = stepRealm;
        }
        this.clearReentryToken();
      } else {
        const resourceUrlParam = params.get('resourceURL');
        if (resourceUrlParam) params.delete('resourceURL');
        // Rest does not accept the params listed in the array below as is
        // they must be transformed into the "authIndexType" and "authIndexValue" params
        // there should only be one authIndexType/Value per request
        each(['authlevel', 'module', 'service', 'user', 'resource'], (param) => {
          if (params.get(param)) {
            const resourceDefinedWithoutUrl = param === 'resource' && !resourceUrlParam;
            if (resourceDefinedWithoutUrl) {
              return;
            }

            const indexValue = param === 'resource' ? resourceUrlParam : params.get(param);

            params.delete(param);
            params.set('authIndexType', param === 'authlevel' ? 'level' : param);
            params.set('authIndexValue', indexValue);
          }
        });

        if (this.$route.params.tree) {
          this.treeId = this.$route.params.tree;
        } else if (params.get('authIndexValue') && params.get('authIndexType') === 'service') {
          this.treeId = params.get('authIndexValue');
        }

        this.removeUrlParams();
        const stringParams = createParamString(params);
        window.history.replaceState(null, null, `?realm=${this.realm}${stringParams}${hash}`);
      }
    },
    /**
     * @description gets field information
     * @param {Object} callback specific step callback
     * @param {Object} index callback index
     * @returns {Object} field props needed for Field component
     */
    getField(callback, index) {
      const callbackType = callback.getType();
      let fieldType;

      switch (callbackType) {
        case FrCallbackType.PasswordCallback:
        case FrCallbackType.ValidatedCreatePasswordCallback:
          fieldType = 'password';
          break;
        case FrCallbackType.NumberAttributeInputCallback:
          fieldType = 'number';
          break;
        default:
          fieldType = 'string';
          break;
      }

      let label = '';
      if (callback.getPrompt) {
        label = callback.getPrompt();
      } else if (callback.getOutputByName) {
        try {
          label = callback.getOutputByName('prompt').value;
        } catch (e) {
          noop();
        }
      }
      return {
        label,
        fieldType,
        name: `callback_${index}`,
        value: callback.getInputValue(),
      };
    },
    /**
     * @description Used to get link to start of tree from stepParams
     * @param {Object} stepParams desctuctured object containing tree, realmPath strings
     * @returns {string} returns string url
     */
    getLinkToTreeStart({ tree, realmPath, query: { goto, gotoOnFail } }) {
      const gotosString = `${goto ? `&goto=${encodeURIComponent(goto)}` : ''}${gotoOnFail ? `&gotoOnFail=${encodeURIComponent(gotoOnFail)}` : ''}`;
      let prefix = '';
      if (window.location.hostname.startsWith("login")) prefix = '/am/XUI';
      return `${prefix}/?realm=${realmPath}&authIndexType=service&authIndexValue=${tree}${gotosString}`;
    },
    /**
     * @description Used to get listeners for callback components
     * @param {Object} properties object of any properties needed to have listeners context
     * @param {Array} listenerArray array of string names to populate component listeners
     * @returns {Object} returns object populated with specified listener functions
     */
    getListeners({ callback, index }, listenerArray = []) {
      const listeners = {
        'did-consent': (consent) => {
          this.step.callbacks.forEach((callbackItem) => { callbackItem.setInputValue(consent); });
        },
        'disable-next-button': (bool) => {
          this.nextButtonDisabledArray.splice(index, 1, bool);
        },
        'has-scripts': (appendScript) => {
          this.showScriptElms = true;
          // listen on body.appendchild and append to #body-append-el insted
          const observer = new MutationObserver((records) => {
            const nodeList = records[records.length - 1].addedNodes || [];
            Array.prototype.forEach.call(nodeList, (node) => {
              document.getElementById('body-append-el').appendChild(node);
            });
            observer.disconnect();
          });
          observer.observe(document.body, { childList: true });
          // only hide next button if we know it should be hidden (webAuthn, deviceId)
          if (this.backendScriptsIdsContains('clientScriptOutputData')) {
            this.nextButtonVisible = false;
          }
          setTimeout(() => {
            this.$nextTick(appendScript);
          }, 20);
        },
        'hide-next-button': (bool) => {
          this.nextButtonVisible = !bool;
        },
        'hidden-value-callback-ref': (ref) => {
          this.hiddenValueCallbacksRefs.push(ref);
        },
        'next-step-callback': (cb) => {
          this.nextStepCallbacks.push(cb);
        },
        'update-auth-id': (authId) => {
          this.step.payload.authId = authId;
        },
        // event emited from FrField
        input: (value) => {
          if (callback && callback.setInputValue) {
            callback.setInputValue(value);
            if (value) {
              this.nextButtonDisabledArray.splice(index, 1, false);
            } else if (this.isCallbackRequired(callback)) {
              this.nextButtonDisabledArray.splice(index, 1, true);
            }
          }
        },
      };
      return listenerArray.reduce((acc, listener) => ({ ...acc, [listener]: listeners[listener] }), {});
    },
    /**
     * @description If session storage has step information, extract it and clear session storage
     * @returns {Object} two properties needed to resume tree: step and authIndex value
     */
    getStepFromStorage() {
      const step = sessionStorage.getItem('step');
      const authIndexValue = sessionStorage.getItem('authIndexValue');
      const realm = sessionStorage.getItem('realm');
      if (step !== null && authIndexValue !== null && realm !== null) {
        sessionStorage.removeItem('step');
        sessionStorage.removeItem('authIndexValue');
        sessionStorage.removeItem('realm');
        return { step: JSON.parse(step), authIndexValue, realm };
      }
      return { step: undefined, authIndexValue: undefined, realm: undefined };
    },
    getStepParams() {
      const paramString = this.getCurrentQueryString();
      const paramsObj = this.parseParameters(paramString);
      if (paramsObj.authIndexValue) {
        paramsObj.authIndexValue = decodeURI(paramsObj.authIndexValue);
      }
      const stepParams = {
        query: {},
        tree: this.treeId || this.$route.params.tree || undefined,
        realmPath: this.realm,
      };

      // Set the SDK tree property from the URL if a tree is being accessed and none of the other local variables have defined one
      if (paramsObj.authIndexType === 'service' && paramsObj.authIndexValue && typeof stepParams.tree === 'undefined') {
        stepParams.tree = paramsObj.authIndexValue;
      }

      // remove tree from stepParams when undefined
      if (stepParams.tree === undefined || stepParams.tree === 'undefined') {
        delete stepParams.tree;
      }

      if (this.suspendedId) {
        stepParams.query.suspendedId = this.suspendedId;
        stepParams.query.goto = (paramsObj.goto) ? decodeURIComponent(paramsObj.goto) : undefined;
        stepParams.query.gotoOnFail = (paramsObj.gotoOnFail) ? decodeURIComponent(paramsObj.gotoOnFail) : undefined;
      } else {
        stepParams.query = paramsObj;
        stepParams.query.code = this.code ? this.code : undefined;
        stepParams.query.state = this.state ? this.state : undefined;
        stepParams.query.scope = this.scope ? this.scope : undefined;
        stepParams.query.goto = (paramsObj.goto) ? decodeURIComponent(paramsObj.goto) : undefined;
        stepParams.query.gotoOnFail = (paramsObj.gotoOnFail) ? decodeURIComponent(paramsObj.gotoOnFail) : undefined;
      }
      // stepParams.query.realm never needs to be included. We are already sending stepParams.realmPath which is what the
      // sdk uses to build the authenticate url ('/am/json/realms/root/realms/alpha/authenticate').
      // When realm is included ('/am/json/realms/root/realms/alpha/authenticate?realm=/alpha') this can confuse
      // some parts of am like SAML (see FRAAS-6573).
      delete stepParams.query.realm;

      // locale is set by the request header through sdk config. Sending this query param causes unexpected responses from AM
      // with differences between chains and trees. More consistent to just rely on the request header (see IAM-1440)
      delete stepParams.query.locale;
      return stepParams;
    },
    getTranslatePolicyFailures(callback) {
      const failedPolicies = callback.getFailedPolicies
        ? callback.getFailedPolicies()
        : [];
      return failedPolicies.map((policy) => {
        const parsedPolicy = JSON.parse(policy);
        return this.$t(`common.policyValidationMessages.${parsedPolicy.policyRequirement}`, parsedPolicy.params);
      });
    },
    /**
     * @description Returns boolean true if reentry cookie is set
     * @returns {Boolean}
     */
    hasReentryToken() {
      return !!document.cookie
        .split('; ')
        .find((row) => row.startsWith('reentry='));
    },
    /**
     * @description Determines if passed in callback is set to required or has a required policy
     * @param {Object} callback - callback to check if required
     * @returns {Boolean} True if passed in callback is required
     */
    isCallbackRequired(callback) {
      const requiredOutput = callback.getOutputByName('required');
      if (requiredOutput === true && callback.getType() !== 'BooleanAttributeInputCallback') {
        return true;
      }
      const policyOutput = callback.getOutputByName('policies');
      if (has(policyOutput, 'policies')) {
        const requiredPolicy = policyOutput.policies.find((policy) => policy.policyId === 'required');
        if (has(requiredPolicy, 'policyRequirements') && requiredPolicy.policyRequirements.includes('REQUIRED')) {
          return true;
        }
      }
      return false;
    },
    /**
     * @description Returns boolean true if payload has session timeout error code
     * @param {Object} payload - step payload data
     * @returns {Boolean}
     */
    isSessionTimedOut(payload) {
      return (
        (payload.detail && payload.detail.errorCode === '110')
        || (this.suspendedId && payload.code.toString() === '401')
      );
    },
    /**
     * @description Gets callbacks needed for authentication when this.step is undefined, and submits callback values when
     * this.step is defined. Then determines based on step.type what action to take.
     */
    nextStep(event, preventClear) {
      if (event) {
        event.preventDefault();
      }
      // for when no change is expected between steps (stops a flash of white from rerender)
      if (!preventClear) {
        this.loading = true;
        this.showScriptElms = false;
        this.hiddenValueCallbacksRefs = [];
      }
      this.loginFailure = false;
      this.linkToTreeStart = '';

      // invoke callbacks before nextStep
      // if a callback returns a promise, the promise is pushed to an array
      const callbackPromises = [];
      while (this.nextStepCallbacks.length) {
        const cb = this.nextStepCallbacks.shift();
        const returnPromise = cb();
        if (returnPromise && typeof returnPromise === 'object' && typeof returnPromise.then === 'function') {
          callbackPromises.push(returnPromise);
        }
      }
      // the array of promises is waited on to continue execution until all have resolved
      if (callbackPromises.length) {
        Promise.all(callbackPromises).finally(
          () => this.nextStep(event, preventClear),
        );
        return;
      }

      // Registration flow processing
      let authTree = this.treeId || this.$route.params.tree;
      if ((authTree === 'CORPlatformRegistration')||(authTree === 'CORPlatformRegistration2')||(authTree === 'CORPlatformRegistrationMobile')) {
        // TODO
      }

      const stepParams = this.getStepParams();
      FRAuth.next(this.step, stepParams)
        .then((step) => {
          let initialStep;
          const realmAndTreeInitialStep = JSON.parse(sessionStorage.getItem('initialStep'));
          const realmAndTreeKey = `${stepParams.realmPath}/${stepParams.tree || ''}`;
          if (realmAndTreeInitialStep && realmAndTreeInitialStep.key === realmAndTreeKey) {
            initialStep = new FRStep(realmAndTreeInitialStep.step.payload);
          } else if (step.type !== 'LoginFailure') {
            sessionStorage.setItem('initialStep', JSON.stringify(
              {
                key: realmAndTreeKey,
                step,
              },
            ));
          }
          const previousStep = this.step;
          this.step = step;

          // these step params only need to be sent one time
          if (this.code || this.state || this.scope) {
            this.code = undefined;
            this.state = undefined;
            this.scope = undefined;
          }

          switch (step.type) {
            case 'LoginSuccess':
              // If we have a session token, get user information
              sessionStorage.removeItem('initialStep');
              this.getIdFromSession()
                .then(this.getUserInfo)
                .then((userObj) => {
                  let isAdmin = false;
                  const rolesArray = userObj.data.roles;

                  if (rolesArray.includes('ui-global-admin') || rolesArray.includes('ui-realm-admin')) {
                    isAdmin = true;
                  }
                  return this.verifyGotoUrlAndRedirect(step.getSuccessUrl(), this.realm, isAdmin);
                })
                .then((res) => {
                  window.location.href = res;
                })
                .catch(() => {
                  // attempt to redirect user on failure
                  this.verifyGotoUrlAndRedirect(step.getSuccessUrl(), this.realm, false)
                    .then((res) => {
                      window.location.href = res;
                    });
                });
              break;
            case 'LoginFailure':
              this.loading = true;
              if (this.retry && this.isSessionTimedOut(step.payload)) {
                this.retry = false;
                this.retryWithNewAuthId(previousStep, stepParams);
              } else if (this.suspendedId && this.isSessionTimedOut(step.payload)) {
                this.errorMessage = step.payload.message || this.$t('login.loginFailure');
                this.linkToTreeStart = this.getLinkToTreeStart(stepParams);
                this.loading = false;
              } else {
                this.errorMessage = step.payload.message || this.$t('login.loginFailure');
                this.redirectToFailure(step);
                this.step = initialStep;
                this.retry = true;
                if (this.step && this.step.callbacks) {
                  this.componentList = [];
                  this.buildTreeForm();
                }
                this.loading = false;
              }
              this.loginFailure = true;
              break;
            default:
              // retry only when previous was undefined (first step)
              this.retry = !previousStep;

              // check if we are still polling with the same callbacks and set loading to false
              if (preventClear && previousStep) {
                const arrayLengthMatch = previousStep.callbacks.length === step.callbacks.length;
                let sameCallbacks;
                if (arrayLengthMatch) {
                  sameCallbacks = previousStep.callbacks.every((prevCallback, i) => prevCallback.getType() === step.callbacks[i].getType());
                }
                this.loading = !(arrayLengthMatch && sameCallbacks);
                this.showScriptElms = arrayLengthMatch && sameCallbacks;
              }
              // setup the form based on callback info/values obtained from this.step
              this.buildTreeForm();
              this.loading = false;
              break;
          }
          this.$emit('set-theme', this.realm, this.treeId, this.nodeThemeId);
        },
        () => {
          this.$emit('component-ready', 'error');
          this.errorMessage = this.$t('login.issueConnecting');
          this.redirectToFailure(this.step);
          this.loading = false;
        });
    },
    /**
     * Determine if there is a gotoOnFail parameter. If it exists, verify and redirect to that url or hash
     * Redirect to failureUrl when it exists, and display login failure message if not
     *
     * @param {Object} step - callback metadata containing url of failure
     */
    redirectToFailure(step) {
      const urlParams = new URLSearchParams(window.location.search);
      const gotoOnFail = urlParams.get('gotoOnFail');

      if (gotoOnFail) {
        this.verifyGotoUrlAndRedirect(gotoOnFail, this.realm, false, true)
          .then((res) => {
            if (res && res.length) {
              window.location.href = encodeURI(res);
            } else if (has(step, 'payload.detail.failureUrl') && step.payload.detail.failureUrl.length) {
              window.location.href = step.payload.detail.failureUrl;
            }
          })
          .catch((error) => {
            this.displayNotification('IDMMessages', 'error', error.response.data.message);
          });
      } else if (has(step, 'payload.detail.failureUrl') && step.payload.detail.failureUrl.length) {
        window.location.href = step.payload.detail.failureUrl;
      }
    },
    removeUrlParams() {
      // remove query params from the url
      window.history.replaceState(null, null, window.location.pathname);
      // if a tree is defined reset the hash to the proper tree
      if (this.treeId) {
        window.location.hash = `service/${this.treeId}`;
      }
    },
    /**
     * Retry a previously failed step with a new authId. The new authId is acquired by calling FRAuth.next with no step.
     * Then a this.nextStep is called with the previously failed step and new authId
     *
     * @param {Object} previousStep - previous step data with prototype intact
     * @param {Object} stepParams - step params
     *
     */
    retryWithNewAuthId(previousStep, stepParams) {
      FRAuth.next(undefined, stepParams)
        .then((step) => {
          const { authId } = step.payload;
          this.step = previousStep;
          if (has(this.step, 'payload')) {
            this.step.payload.authId = authId;
          }
          this.nextStep();
        });
    },
    setRealm(config) {
      this.realm = config ? config.data.realm : '/';
    },
    /**
     * Sets page title depending on the journey service type
     *
     * @param {String} hash - window.location.hash
     * @param {Oject} params - params.get(string)
     *
     */
    setPageTitle(hash, params) {
      // For the following registration url params:
      // &authIndexType=service&authIndexValue=Registration
      if (params && params.get('authIndexType') === 'service' && params.get('authIndexValue')) {
        document.title = params.get('authIndexValue');

      // For the following registration url:
      // #/service/Registration
      } else if (hash.includes('service')) {
        const hashSplit = hash.split('/');
        const serviceIndex = hashSplit.indexOf('service');
        // makes sure that the hashSplit array has at least one more element after 'service'
        const serviceValueExists = (serviceIndex + 2) >= hashSplit.length;

        if (serviceIndex !== -1 && serviceValueExists) {
          const title = hashSplit[serviceIndex + 1];
          // in the event that the remaining url contains query params
          if (title.includes('?')) {
            const titleSplitByParam = title.split('?')[0];
            document.title = titleSplitByParam;
          } else {
            document.title = title;
          }
        }
      }
    },
    searchField(name) {
        for (const comp of this.componentList) {
            if (name === "[NameCallback]") {  // 
                // Looking for the user name (before validation)
                if (comp.callback.getType() === "NameCallback") return comp;
            } else if (name === "[ValidatedCreateUsernameCallback]") {
                if (comp.callback.getType() === "ValidatedCreateUsernameCallback") return comp;
            } else if (name === "[ValidatedCreatePasswordCallback]") {
                // Looking for the password (after validation)
                if (comp.callback.getType() === "ValidatedCreatePasswordCallback") return comp;
            } else {
                // Attribute etc
                let compName = this.getFieldName(comp);
                if (name === compName) return comp;
            }
        };
        return undefined;   // not found
    },
    getFieldName(component) {
        let callback = component.callback;
        if (callback.getName) return callback.getName();

        // No name.  See if it is userName or password
        let type = callback.getType();
        if (type === 'NameCallback')
            return '[NameCallback]';
        else if (type === 'ValidatedCreateUsernameCallback')
            return '[ValidatedCreateUsernameCallback]';
        else if (type === 'ValidatedCreatePasswordCallback')
            return '[ValidatedCreatePasswordCallback]';

        return "";
    },
    setCallbackField(callback, field, value) {
        if (callback.payload) {
            let output = callback.payload.output;
            if (output && output.length > 0) {
                for (const ele of output) {
                    if (ele.name === field) {
                        ele.value = value;
                        return true;
                    }
                }
            }
        }
        return false;
    },
  },
};

// syeung: Workaround to set User Name field's label to Email
// Should find a more elegant solution when have time
function COR_UI_workaround() {
  //return; // vchu1: fixed in default locale (src/locales/en.json) as overrides.UserName.  See COR-readme.md for detail

  console.log("syeung: index.vue hardcoded change on Username label & keydown event.");
  var UsernameInput = document.querySelectorAll("[data-vv-as='User Name']")[0];
  var EmailInput = document.querySelectorAll("[data-vv-as='Username']")[0];  
  var PasswordInput = document.querySelectorAll("[data-vv-as='Password']")[0];
  var DateOfBirthInput = document.querySelectorAll("[data-vv-as='Date of Birth']")[0];

  if (UsernameInput || EmailInput || PasswordInput || DateOfBirthInput) {
    clearInterval(checkExist);
  } else {
    return;
  }

  if (UsernameInput && UsernameInput.labels[0]) {
    if (PasswordInput) {  
      UsernameInput.onkeydown = function (e) {
        if (e.keyCode == 13) { // Enter Key
          PasswordInput.focus();
          return false;
        }
      }
    }
  }

  if (EmailInput) {
      EmailInput.onkeyup = function (e) {
        e.target.value = e.target.value.trim();
        e.target.dispatchEvent(new Event('input', {bubbles:true})); // Needed to renew form summit data
      };
  }

  if (DateOfBirthInput) {
    DateOfBirthInput.maxLength = 8;
    DateOfBirthInput.onkeypress = function (e) {
      var keyCode = window.event ? window.event.keyCode : e.keyCode;
      return keyCode >= 48 && keyCode <=57; // 0-9
    };
    DateOfBirthInput.onblur = function (e) {
      if (isNaN(e.target.value) || e.target.value.length != 8) {
        e.target.value = "";
        e.target.dispatchEvent(new Event('input', {bubbles:true})); // Needed to renew form summit data
      }
    };
  }

  if (document.forms[0]) {
    document.forms[0].onsubmit = function (e) {
      checkExist = setInterval(COR_UI_workaround, 100);
    }
  }
}

var checkExist = setInterval(COR_UI_workaround, 100); // workaround timing issue

</script>

<style lang="scss" scoped>
/* when the form-factor is small, hide the sidebar */
@media (max-width: 64rem) {
  .sidebar {
    display: none;
  }
}

// smartphone portrait
@media (max-width: 576px) {
  .card-body {
    padding-left: 0;
    padding-right: 0;
  }
  .form {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .logo {
    padding-left: 1rem;
  }
}

@media (min-width: 600px) {
  .content {
    width: 600px;
  }
}

#callbacksPanel ::v-deep {
  span.material-icons {
    line-height: 22px;
  }

  .callback-component:not(:last-of-type):not(.hidden) {
    margin-bottom: 1rem;
  }

  .hide-polling-spinner ~ .polling-spinner-container {
    display: none;
  }

  .max-width-600 {
    max-width: 600px;
  }

  .journey-card {
    background-color: $white;
  }
}

.card-footer {
  border: 0;
  padding: 0;
}

input:focus,
input:not(:placeholder-shown) {
  padding-top: $input-btn-padding-y + $input-btn-padding-y * calc(2 / 3);
  padding-bottom: calc($input-btn-padding-y / 3);

  ~ label {
    padding-top: calc($input-btn-padding-y / 3);
    padding-bottom: 0;
    font-size: 12px;
  }
}

@media (min-width: 768px) {
  .w-md-50 {
    width: 50% !important;
  }
}

@media (max-width: 576px) {
  .fr-fullscreen-mobile {
    .container,
    .col-lg-12 {
      margin: 0;
      padding: 0;
      height: 100%;
    }
  }
}

.fr-center-card {  // override fr-center-card that makes display narrow
  @include media-breakpoint-between(sm, xl) {
    max-width: 960px;
    padding: 10px 0;
  }
}

.container-login {
  display: flex;
  flex-direction: row;
  flex-wrap:nowrap;
  align-items: flex-start;
  justify-content: center;
  margin: 0 auto;
  padding: 0 clamp(16px, 7vw, 48px);
  position: relative;
}
</style>

<style lang="scss">
.corPasswordRevealButton {
  line-height: 1rem !important;
}

</style>
